<template>
  <div class="km-navbar">
    <div class="navbar-container">
      <!-- Logo -->
      <div class="navbar-logo" @click="handleSkipHomePage">
        <div class="logo-icon">
          <span>柯</span>
        </div>
        <div class="logo-text-wrap">
          <span class="logo-main">{{ showFullText ? '宁国市柯美自动化设备制造有限公司' : '柯美自动化' }}</span>
        </div>
      </div>

      <!-- 桌面端菜单 -->
      <nav class="navbar-menu" v-if="showFullText">
        <a v-for="item in menus" :key="item.value" :class="['menu-item', { active: activeName === item.value }]" @click="handleMenuClick(item)">
          {{ item.text }}
        </a>
        <a class="menu-contact-btn" @click="handleMenuClick(menus[2])">联系我们</a>
      </nav>

      <!-- 移动端汉堡按钮 -->
      <button class="mobile-menu-btn" v-else @click="showMobileMenu = !showMobileMenu" :class="{ open: showMobileMenu }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 移动端菜单 -->
    <transition name="slide-down">
      <div class="mobile-menu" v-if="showMobileMenu && !showFullText">
        <a
          v-for="item in menus"
          :key="item.value"
          :class="['mobile-menu-item', { active: activeName === item.value }]"
          @click="handleMenuClick(item)"
        >
          <Icon :type="item.icon" size="20" />
          <span>{{ item.text }}</span>
          <Icon type="ios-arrow-forward" size="16" class="arrow-icon" />
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'home',
      menus: [
        { text: '首页', to: '/', icon: 'ios-home', value: 'home' },
        { text: '产品中心', to: '/prod-list', icon: 'ios-apps', value: 'product' },
        { text: '联系我们', to: '/contact', icon: 'ios-call', value: 'contact' },
        { text: '关于我们', to: '/about', icon: 'ios-people', value: 'about' },
      ],
      showFullText: window.innerWidth > 768,
      showMobileMenu: false,
    };
  },
  mounted() {
    this.handleResize();
    this.syncActiveFromRoute();
    window.addEventListener('resize', this.handleResize);
    this.$router.afterEach(() => {
      this.syncActiveFromRoute();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.showFullText = window.innerWidth > 768;
      if (this.showFullText) {
        this.showMobileMenu = false;
      }
    },
    syncActiveFromRoute() {
      const path = this.$route ? this.$route.path : '/';
      if (path === '/') this.activeName = 'home';
      else if (path.startsWith('/prod')) this.activeName = 'product';
      else if (path === '/contact') this.activeName = 'contact';
      else if (path === '/about') this.activeName = 'about';
    },
    handleSkipHomePage() {
      this.$router.push('/');
      this.activeName = 'home';
      this.showMobileMenu = false;
    },
    handleMenuClick(item) {
      this.$router.push(item.to);
      this.activeName = item.value;
      this.showMobileMenu = false;
    },
  },
};
</script>

<style lang="less" scoped>
.km-navbar {
  width: 100%;
  background: transparent;
  position: relative;
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.navbar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ff8c00, #ffa733);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.4);
  flex-shrink: 0;
}

.logo-text-wrap {
  .logo-main {
    font-size: 17px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.3px;
    line-height: 1.3;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }
}

/* 桌面端菜单 */
.navbar-menu {
  display: flex;
  align-items: center;
  gap: 4px;
}

.menu-item {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  text-decoration: none;
  position: relative;

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.12);
  }

  &.active {
    color: #ff8c00;
    background: rgba(255, 140, 0, 0.15);

    &::after {
      content: '';
      position: absolute;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 2px;
      background: #ff8c00;
      border-radius: 2px;
    }
  }
}

.menu-contact-btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 20px;
  background: #ff8c00;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  text-decoration: none;
  margin-left: 8px;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.35);

  &:hover {
    background: #e67e00;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(255, 140, 0, 0.45);
    color: #ffffff;
  }
}

/* 移动端汉堡按钮 */
.mobile-menu-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  padding: 8px;
  cursor: pointer;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  transition: background 0.2s;

  span {
    display: block;
    width: 22px;
    height: 2px;
    background: #ffffff;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }

  &.open {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

/* 移动端菜单 */
.mobile-menu {
  position: absolute;
  top: 68px;
  left: 0;
  right: 0;
  background: #003d82;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  z-index: 100;
  overflow: hidden;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 24px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);

  .arrow-icon {
    margin-left: auto;
    opacity: 0.5;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #ffffff;
  }

  &.active {
    color: #ff8c00;
    background: rgba(255, 140, 0, 0.1);
  }

  &:last-child {
    border-bottom: none;
  }
}

/* Slide animation */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.25s ease;
  max-height: 400px;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

/* 响应式 */
@media (max-width: 768px) {
  .navbar-container {
    height: 60px;
    padding: 0 16px;
  }

  .logo-icon {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }

  .logo-text-wrap .logo-main {
    font-size: 15px;
  }

  .mobile-menu {
    top: 60px;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    height: 56px;
    padding: 0 12px;
  }

  .logo-icon {
    width: 34px;
    height: 34px;
    font-size: 16px;
  }

  .logo-text-wrap .logo-main {
    font-size: 14px;
  }

  .mobile-menu {
    top: 56px;
  }
}
</style>
